export const projectOne = {
  id: 'Project',
  lightBg: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Project 1',
  headline: 'MSU Konnect',
  description:
    "MSU Konnect will allow students to create their own websites to show off their portfolio/resume easily - with no need of prior coding knowledge! In this day and age, it's vital for one to have an online presence to be competitive in the job market. With MSU Konnect, students will be able to select a variety of website templates to choose from that will build automatically for them. You will be able to fill in a form with information about yourself and the rest will be taken care of!",
  buttonLabel: 'Demo',
  buttonLabel2: "Infomercial",
  imgStart: true,
  img: require('../../images/MSUkonnect.png'),
  alt: 'MSU Konnect',
  dark: true,
  primary: true,
  darkText: false
};
